export default "__VITE_ASSET__5oi2bSmN__"